import Vue from 'vue'

// 自动引入当前路径下的所有组件
const componentsContext = require.context('./', true, /\.vue$/)
componentsContext.keys().forEach(component => {
  const componentConfig = componentsContext(component)

  const ctrl = componentConfig.default || componentConfig
  Vue.component(ctrl.name, ctrl)
})
